import postAPI from './postAPI.js'

export default async function postAddInstanceField(body) {
    const data = await postAPI('admin/taskinstances/steps/fields/add', body);
    return data;
}
